/**
 * @class ColorantPackageStock
 */
export default class ColorantPackageStock {
    /**
     * @param {String}  key
     * @param {String}  packageName
     * @param {String}  colorantName
     * @param {Number}  value
     * @param {String}  databaseName
     */
    constructor(key, packageName, colorantName, databaseName, value = 0) {
        this.key = key;
        this.package = packageName;
        this.colorant = colorantName;
        this.database = databaseName;
        this.value = value;
        this.confirmed = false;
    }

    /**
     * @return {String}
     */
    toString() {
        return "ColorantPackageStock (" + this.key + ")";
    }
}
